import { gql } from '@apollo/client';

export const CREATE_AI_FEEDBACK = gql`
  mutation CreateAIFeedback(
    $patientId: ID!
    $summaryContent: JSONString
    $page: String
    $comments: String
    $category: String
    $traceId: String
    $spanId: String
  ) {
    createAiFeedback(
      patientId: $patientId
      summaryContent: $summaryContent
      page: $page
      comments: $comments
      category: $category
      traceId: $traceId
      spanId: $spanId
    ) {
      success
    }
  }
`;
